import React, { useState } from "react";
import { toast } from "sonner";
import { formatCOP, formatApiError } from "../../lib/apiClient";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function BudgetEditor({ budget, range, onSave }) {
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState(String(Math.round(budget || 0)));
  const [busy, setBusy] = useState(false);
  const num = Number(String(val).replace(/\D/g, ""));
  const submit = async () => {
    if (!num) return toast.error("Ingrese un valor en pesos mayor que cero.");
    setBusy(true);
    try {
      await onSave(num);
      toast.success("Presupuesto actualizado en su borrador");
      setOpen(false);
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "No se pudo actualizar el presupuesto");
    } finally {
      setBusy(false);
    }
  };
  if (!open) {
    return (
      <Button size="sm" variant="outline" onClick={() => setOpen(true)} className="mt-2 h-8 rounded-sm text-xs border-amber-400 bg-white" data-testid="budget-edit-open">
        Corregir presupuesto
      </Button>
    );
  }
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2" data-testid="budget-editor">
      <label htmlFor="budget-input" className="text-xs">Nuevo presupuesto (COP)</label>
      <Input id="budget-input" inputMode="numeric" value={val} onChange={(e) => setVal(e.target.value)} className="h-8 w-44 text-xs rounded-sm bg-white" data-testid="budget-edit-input" />
      <Button size="sm" variant="ghost" onClick={() => setVal(String(Math.round((range.low + range.high) / 2)))} className="h-8 text-xs" data-testid="budget-use-range">
        Usar punto medio del rango ({formatCOP((range.low + range.high) / 2)})
      </Button>
      <Button size="sm" onClick={submit} disabled={busy} className="h-8 rounded-sm text-xs" data-testid="budget-edit-save">
        {busy ? "Guardando…" : "Guardar en el borrador"}
      </Button>
      <Button size="sm" variant="ghost" onClick={() => setOpen(false)} className="h-8 text-xs" data-testid="budget-edit-cancel">Cancelar</Button>
      <p className="w-full text-[11px] text-amber-800">Se crea una nueva versión del borrador. El diagnóstico actual seguirá basado en la versión anterior.</p>
    </div>
  );
}
